import { CLINIC, whatsappLink } from "@/lib/clinic";
import { Instagram, Facebook, MessageCircle } from "lucide-react";

export default function Footer() {
    return (
        <footer
            className="bg-[#1A221F] text-[#E8E6E1]"
            data-testid="footer"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20 grid md:grid-cols-4 gap-10">
                <div className="md:col-span-2">
                    <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-full bg-[#8A9A5B] flex items-center justify-center text-white font-display font-semibold">
                            M
                        </div>
                        <span className="font-display text-2xl text-white">
                            Mirrari Clinic
                        </span>
                    </div>
                    <p className="text-sm text-[#B8B5AD] mt-5 max-w-sm leading-relaxed">
                        Amravati's premium destination for dermatology, venereology and
                        comprehensive dental care. Built around your comfort.
                    </p>
                </div>

                <div>
                    <div className="text-xs uppercase tracking-[0.3em] text-[#8A9A5B]">
                        Contact
                    </div>
                    <ul className="mt-5 space-y-2 text-sm">
                        <li>
                            <a
                                href={`tel:${CLINIC.phoneRaw}`}
                                className="hover:text-white transition-colors"
                                data-testid="footer-phone"
                            >
                                {CLINIC.phone}
                            </a>
                        </li>
                        <li className="text-[#B8B5AD]">{CLINIC.hours}</li>
                        <li className="text-[#B8B5AD] leading-relaxed">
                            {CLINIC.shortAddress}
                        </li>
                    </ul>
                </div>

                <div>
                    <div className="text-xs uppercase tracking-[0.3em] text-[#8A9A5B]">
                        Connect
                    </div>
                    <div className="flex gap-3 mt-5">
                        <a
                            href={whatsappLink()}
                            target="_blank"
                            rel="noreferrer"
                            className="w-10 h-10 rounded-full bg-white/5 hover:bg-[#25D366] flex items-center justify-center transition-colors"
                            aria-label="WhatsApp"
                            data-testid="footer-whatsapp"
                        >
                            <MessageCircle className="w-4 h-4" />
                        </a>
                        <a
                            href="#"
                            className="w-10 h-10 rounded-full bg-white/5 hover:bg-white/15 flex items-center justify-center transition-colors"
                            aria-label="Instagram"
                            data-testid="footer-instagram"
                        >
                            <Instagram className="w-4 h-4" />
                        </a>
                        <a
                            href="#"
                            className="w-10 h-10 rounded-full bg-white/5 hover:bg-white/15 flex items-center justify-center transition-colors"
                            aria-label="Facebook"
                            data-testid="footer-facebook"
                        >
                            <Facebook className="w-4 h-4" />
                        </a>
                    </div>
                </div>
            </div>
            <div className="border-t border-white/10">
                <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[#B8B5AD]">
                    <span>
                        © {new Date().getFullYear()} Mirrari Clinic · All rights reserved.
                    </span>
                    <span>Designed by Orison Info System Pvt Ltd</span>
                </div>
            </div>
        </footer>
    );
}
